import { Badge, Box, Button, Heading, Table, Tbody, Td, Text, Th, Thead, Tr, VStack, useDisclosure } from '@chakra-ui/react';
import { formattedCurrency } from '../../../helper/utils/formattedCurrency';
import TransactionDetailModal from '../components/TransactionDetailModal';
import useHistoryTransactions from '../hooks/useHistoryTransactions';

export default function CreditBalance() {
    const { historyTransactions, handleGetHistoryTransactionDetail, historyTransactionDetail } = useHistoryTransactions();
    const { isOpen, onOpen, onClose } = useDisclosure();

    const creditTransactions = historyTransactions;

    const getStatusColor = (status) => {
        const statusColors = {
            completed: 'green',
            success: 'green',
            pending: 'yellow',
            failed: 'red',
            expire: 'red',
            cancelled: 'gray',
        };
        return statusColors[status?.toLowerCase()] || 'gray';
    };

    return (
        <VStack spacing={{ base: 4, md: 6 }} align='stretch' w='full'>
            <Box mt={{ base: 5, md: 0 }} mb={3}>
                <Heading size={{ base: 'md', md: 'lg' }} color='gray.800' mb={{ base: 0, md: 2 }} textAlign={{ base: 'center', md: 'left' }}>
                    Credit Balance
                </Heading>
                <Text color='gray.600' fontSize={{ base: 'sm', md: 'md' }} textAlign={{ base: 'center', md: 'left' }}>
                    View your credit balance and transaction history
                </Text>
            </Box>

            {/* Current Balance Card */}
            {/* <Box bg='linear-gradient(135deg, #FFA500 0%, #FF8C00 100%)' borderRadius='2xl' p={{ base: 6, md: 8 }} color='white'>
                <Text fontSize={{ base: 'sm', md: 'md' }} opacity={0.9} mb={2}>
                    Current Balance
                </Text>
                <Heading size={{ base: 'xl', md: '2xl' }}>Rp {creditBalance.toLocaleString('id-ID')}</Heading>
            </Box> */}

            {/* Transaction History */}
            <Box bg='white' borderRadius='2xl' p={{ base: 4, md: 6 }} border='1px' borderColor='gray.100'>
                <Heading size={{ base: 'sm', md: 'md' }} color='gray.800' mb={4}>
                    Transaction History
                </Heading>

                {creditTransactions.length === 0 ? (
                    <Text color='gray.500' textAlign='center' py={8}>
                        No transactions yet
                    </Text>
                ) : (
                    <>
                        {/* Desktop: Table View */}
                        <Box overflowX='auto'>
                            <Table variant='simple'>
                                <Thead>
                                    <Tr>
                                        <Th>No</Th>
                                        <Th>Date</Th>
                                        <Th>Bill No / ID</Th>
                                        <Th isNumeric>Amount</Th>
                                        <Th>Status</Th>
                                        <Th>Actions</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {creditTransactions.map((transaction, index) => (
                                        <Tr key={transaction.id}>
                                            <Td>{index + 1}</Td>
                                            <Td fontSize='sm'>{transaction.billDate}</Td>
                                            <Td textTransform='uppercase'>#{(transaction.billNo || '0000000000000').slice(0, 8)}</Td>
                                            <Td isNumeric fontWeight='semibold' color={transaction.amount >= 0 ? 'green.600' : 'red.600'}>
                                                {formattedCurrency(transaction.subTotal)}
                                            </Td>
                                            <Td>
                                                <Badge colorScheme={getStatusColor(transaction.orderStatus.toString().toLowerCase())} borderRadius='full' px={3}>
                                                    {transaction.orderStatus}
                                                </Badge>
                                            </Td>
                                            <Td>
                                                <Button size='sm' colorScheme='primary' onClick={() => { handleGetHistoryTransactionDetail(transaction.billNo, transaction.orderType); onOpen(); }}>
                                                    View Detail
                                                </Button>
                                            </Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </Box>
                    </>
                )}
            </Box>

            {/* Modal Detail Transaction */}
            <TransactionDetailModal isOpen={isOpen} onClose={onClose} historyTransactionDetail={historyTransactionDetail} />
        </VStack>
    );
}
